import { render, staticRenderFns } from "./BahanBangunanList.vue?vue&type=template&id=35f0689f&"
import script from "./BahanBangunanList.vue?vue&type=script&lang=js&"
export * from "./BahanBangunanList.vue?vue&type=script&lang=js&"
import style0 from "./BahanBangunanList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports